import * as FIELD_NAME from 'constant/form-item-names'
import { connect } from 'react-redux'
import { Form, Checkbox, Select } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

const { Option } = Select

const SpecialGroupSelect = ({ sites, categoryUuid, categoryObj }) => {
  const handleSpecialUpdate = (prevValues, currentValues) => prevValues.site !== currentValues.site
  const handleUpdate = (prevValues, currentValues) => prevValues.site !== currentValues.site || prevValues.special !== currentValues.special
  return (
    <>
      <Form.Item
        noStyle
        shouldUpdate={handleSpecialUpdate}
      >
        {({ getFieldValue }) => {
          const siteUuid = getFieldValue(FIELD_NAME.SITES)
          if (!siteUuid && !categoryObj.site_uuid) {
            return
          }
          const site = sites.find(({ uuid }) => uuid === siteUuid || uuid === categoryObj.site_uuid)
          return site.special_group?.length
          ? (
            <>
              <Form.Item
                name={FIELD_NAME.SPECIAL}
                valuePropName='checked'
              >
                <Checkbox >Permitted Groups</Checkbox>
              </Form.Item>
            </>
          )
          : null
        }}
      </Form.Item>
      {groupSelect(handleUpdate, sites, categoryObj)}
    </>)
}

const groupSelect = (handleUpdate, sites, category) => (
  <>
    <Form.Item
      noStyle
      shouldUpdate={handleUpdate}
    >
      {({ getFieldValue }) => {
        const siteUuid = getFieldValue(FIELD_NAME.SITES)
        const special = getFieldValue(FIELD_NAME.SPECIAL)
        if (!siteUuid && !category.site_uuid) {
          return
        }
        const site = sites.find(({ uuid }) => uuid === siteUuid || uuid === category.site_uuid)
        return site.special_group?.length && special
            ? (<>
              <Form.Item
                name={FIELD_NAME.USER_TYPE_UUIDS}
              >
                <Select
                  bordered={false}
                  defaultOpen={false}
                  dropdownStyle={{ position: 'relative' }}
                  getPopupContainer={trigger => trigger.parentNode}
                  mode='multiple'
                  placeholder={'Permitted Groups'}
                  showSearch={false}
                  size='large'
                  style={{ background: '#fff' }}
                >
                  {site.special_group.map(({ name, user_type_uuid: uuid }) => (
                    <Option
                      key={uuid}
                      value={uuid}
                    >
                      {_.startCase(name)}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </>
               )
              : null
      }}
    </Form.Item>
  </>)

SpecialGroupSelect.propTypes = {
  categoryObj: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  categoryUuid: PropTypes.string,
  form: PropTypes.object,
  sites: PropTypes.array
}

const mapStateToProps = ({ category, site }, { categoryUuid }) => ({
  categoryObj: categoryUuid
    ? (category.managementCategories.find(({ uuid }) => uuid === categoryUuid))
    : false,
  sites: site.allSites
})

export default connect(mapStateToProps)(SpecialGroupSelect)
